import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { PatientProtocolType, SitePaymentSchedule } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type PaymentSchedulesModel = getEntityType<PaymentSchedulesState>;

export type PaymentSchedulesState = EntityState<
  Omit<
    RequireSome<Partial<SitePaymentSchedule>, 'id'>,
    'expense_amount' | 'patient_protocol' | 'site'
  > & {
    amount?: null | number;
    amount_contract?: null | number;
    completion_date?: null | string;

    external_patient_id?: null | string;
    patient_id?: null | string;

    patient_protocol_id: string;
    patient_protocol_type: PatientProtocolType;

    site_id: string;
    sps_contract_expense_currency?: null | string;

    sps_expense_currency?: null | string;
    total_payment_schedule_amount?: number;
  }
>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'payment-schedules' })
export class PaymentSchedulesStore extends EntityStore<PaymentSchedulesState> {
  constructor() {
    super({});
  }
}
